import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '../hooks'
import { setFilterContext } from './actions'
import { getIsBulkInquirySliceRehydrated } from './selectors'

export const useSyncSelectionFilter = (filter: string): void => {
    const dispatch = useAppDispatch()
    const isRehydrated = useSelector(getIsBulkInquirySliceRehydrated)

    useEffect(() => {
        if (!isRehydrated) {
            return
        }
        dispatch(setFilterContext(filter))
    }, [filter, dispatch, isRehydrated])
}
